import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  role_list_action,
  role_delete_action,
} from "../../../actions/adminModule_action/roles_action";
import { responseError } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";
class roleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      role_id: "",
      Name: "",
      Description: "", is_active: "Active",
      roleList: [],
      filteredData: [],
      statusFillList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.navigateRoleAdd = this.navigateRoleAdd.bind(this);
    this.navigateRoleUpdate = this.navigateRoleUpdate.bind(this);
    this.getRoleList = this.getRoleList.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);
    const { user_id } = this.state;
    this.setState({
      user_id:
        sessionStorage.getItem("user_id") == "" ||
          sessionStorage.getItem("user_id") == null
          ? ""
          : sessionStorage.getItem("user_id"),
    });
    this.getRoleList();
  }

  getRoleList() {
    const { Name,is_active } = this.state;
    this.setState({ isLoading: true });
    this.props
      .role_list_action(Name,is_active==='Active'?1:0)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            roleList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleDelete(role_id) {
    const confirmed = window.confirm(
      "Are you sure you want to delete this Role?"
    );

    if (confirmed) {
      this.props
        .role_delete_action(role_id)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getRoleList(); // Refresh the holiday list after deletion
          } else {
            responseError(data);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  navigateRoleAdd() {
    this.props.navigate("/roleAU", {
      state: { role_id: 0 },
    });
  }
  navigateRoleUpdate(role_id) {
    this.props.navigate(`/roleAU`, {
      state: { role_id: role_id },
    });
  }

  clearFilters() {
    this.setState({
      Name: "",
      is_active:'Active'
    });
    setTimeout(() => {
      this.getRoleList();
    }, 100);
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  roleRecords(roleList) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Role Name</th>
            <th style={{ width: "40%" }}>Role Description</th>
            <th style={{ width: "10%" }}>Status</th>
            <th className="text-right" style={{ width: "4%" }}>
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {roleList.length > 0 ? (
            roleList.map((data) => (
              <tr>
                <td>{data.name}</td>
                <td>{data.description}</td>
                <td>{data.is_active ? "Active" : "Inactive"}</td>
                <td className="text-right">
                  <a
                    href="javascript:void(0);"
                    title="Edit"
                    className="btn btn-sm"
                    onClick={() => this.navigateRoleUpdate(data.role_id)}
                  >
                    <i class="fa fa-pencil-square-o mr-2 text-primary"></i>
                  </a>
                  {data.is_active == 1 ? (
                    <a
                      title="Delete"
                      className="btn btn-sm delete_record"
                      onClick={() => this.handleDelete(data.role_id)}
                    >
                      <i class="fa fa-trash-o text-danger"></i>
                    </a>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <td colSpan={4} className="text-center">
              No records found
            </td>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      roleList,
      currentPage,
      isAccordionExpanded,
      Name,
      is_active,
      role_id,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = roleList?.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(roleList?.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            
                        <div className="website-view">
                          <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                          <MobileHeader data={[8]} />
                        </div>
            {/* <Header data={[20]} /> */}
            <section class='header_margin_top'>
              <div className="container-fluid">
                  <div className="page-header">
                  <h2 class="mb-3 dashboard-tit  py-0 blog-name">List of Role</h2>
                  <button type="btn" className="btn btn-outline-primary" onClick={() => this.navigateRoleAdd()}> Add </button>
                   
                  </div>
                  <div className="search_accordion search_card">
                    <div className="panel-group" id="accordion">
                      <div className="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 className="panel-title">Search</h4>
                          <div className="searched_items">
                            {Name ? <>
                              <h5>
                                <b > Role Name :</b> <span>{Name}</span>
                              </h5>
                            </> : <></>}
                            {is_active ? <>
                              <h5>
                                <b > Status :</b> <span>{is_active}</span>
                              </h5>
                            </> : <></>}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                            }`}
                        >
                          <div className="panel-body p-2">
                            <div className="row mr_0">
                              <div className="col-md-2 ml-2">
                                <div className="form-group">
                                  <label>Role Name</label>
                                  <input
                                    type="text"
                                    className="form-control search_form_control"
                                    placeholder="Enter Role Name"
                                    value={Name}
                                    onChange={(e) =>
                                      this.setState({ Name: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Status</label>
                                  <select
                                    className="form-select"
                                    value={is_active}
                                    onChange={(e) => {
                                      this.setState({
                                        is_active: e.target.value,
                                      });
                                    }}
                                  >
                                    <option key='Active' value="Active">Active</option>
                                    <option key='InActive' value="InActive">In-Active</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <label>&nbsp;</label>
                                <button
                                  onClick={() => this.getRoleList()}
                                  className="btn btn-outline-primary search_btn"
                                >
                                  Search
                                </button>
                                &nbsp;
                                <button
                                  onClick={this.clearFilters}
                                  className="btn btn-outline-danger clr_btn"
                                >
                                  Clear
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="custom_table">
                    <div className="hack1">
                      <div className="hack2">
                        {this.roleRecords(currentRecords)}
                        {roleList?.length > 0 ? (
                          <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={this.updateItem}
                          />
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
            </section>
          </main>

          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { role_list_action, role_delete_action })(roleList)
);
